import request from '@/utils/request';

export function getMajorMonth(params: any) {
  return request({
    url: 'Index/majorMonth',
    method: 'get',
    params: params
  });
}

export function getEngineerStatistics(params: any) {
  return request({
    url: 'Index/engineerStatistics',
    method: 'get',
    params: params
  });
}
export function getMapData(params: any) {
  return request({
    url: 'Index/mapData',
    method: 'get',
    params: params
  });
}

// Dashboard/order
export function dashboardOrderUrl(params: any) {
  return request({
    url: 'Dashboard/orderUrl',
    method: 'get',
    params: params
  });
}
export function dashboardOrderServiceUrl(params: any) {
  return request({
    url: 'Dashboard/orderServiceUrl',
    method: 'get',
    params: params
  });
}
export function dashboardEngineerUrl(params: any) {
  return request({
    url: 'Dashboard/engineerUrl',
    method: 'get',
    params: params
  });
}
export function dashboardCustomerUrl(params: any) {
  return request({
    url: 'Dashboard/customerUrl',
    method: 'get',
    params: params
  });
}
export function dashboardDeviceUrl(params: any) {
  return request({
    url: 'Dashboard/deviceUrl',
    method: 'get',
    params: params
  });
}
export function datavUrl(params: any) {
  return request({
    url: 'Dashboard/datavUrl',
    method: 'get',
    params: params
  });
}
// 导出看板
export function exportEngineer(params: any) {
  return request({
    url: 'Dashboard/exportEngineer',
    method: 'get',
    params: params
  });
}
export function exportCustomer(params: any) {
  return request({
    url: 'Dashboard/exportCustomer',
    method: 'get',
    params: params
  });
}
export function exportDevice(params: any) {
  return request({
    url: 'Dashboard/exportDevice',
    method: 'get',
    params: params
  });
}
// 左侧数字
export function orderServiceCount(params: any) {
  return request({
    url: 'Order/workbench',
    method: 'get',
    params: params
  });
}
